'use client'

import { useState } from 'react'
import { useSession } from 'next-auth/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTag, faLaptop, faPeopleLine } from '@awesome.me/kit-94e593bf23/icons/sharp/light'
import Tooltip from '@/app/_components/Tooltip'

const TradeDetailsSection = () => {
    const { data: session } = useSession()
    const [activeTooltip, setActiveTooltip] = useState(null)

    const isTradeMember = session?.user?.tradeAccount === 1

    const createOpenChangeHandler = (id) => (isOpen) => {
        setActiveTooltip(isOpen ? id : null)
    }

    return (
        <section className="site-padding mb-8 lg:mb-12">
            <div className="flex flex-col lg:flex-row gap-6 lg:gap-16">
                {/* Left: Trade Program Details */}
                <div className="lg:w-2/3">
                    <h2 className="text-2xl lg:text-4xl font-extralight mb-3 lg:mb-6">Trade Program Details</h2>
                    <p className="text-sm lg:text-base mb-2 lg:mb-4">
                        For more than two decades, hive has been a trusted partner to architects and interior designers who refuse to compromise on quality. We understand the demands of the profession — the timelines, the clients, the exacting standards — and we've built our trade program around them.
                    </p>
                    <p className="text-sm lg:text-base mb-2 lg:mb-4">
                        Members enjoy immediate online access to competitive trade pricing across our full collection, alongside direct support from a team of design-fluent professionals available by phone or email to help you spec, quote, and deliver with confidence. And as an authorized dealer for the world's most celebrated design houses — Cassina, Fritz Hansen, Herman Miller, Knoll, Vitra, Flos, and more — we ensure your clients always receive the genuine article.
                    </p>
                    <p className="text-sm lg:text-base mb-2 lg:mb-4">
                        Joining is simple. Complete the form below or call us at{' '}
                        <a href="tel:18666634483" className="font-medium hover:text-primary">(866) 663-4483</a>{' '}
                        to speak with a trade specialist today.
                    </p>



                </div>

                {/* Right: Program Benefits */}
                <div className="lg:w-1/3">
                    <h2 className="text-2xl lg:text-4xl font-extralight mb-3 lg:mb-6">Program Benefits</h2>
                    <div>
                        <div className="py-3 lg:py-6 border-b border-gray-10">
                            <Tooltip
                                content="Exclusive trade discounts across our full collection, available for members."
                                side="bottom"
                                onOpenChange={createOpenChangeHandler('trade-pricing')}
                            >
                                <span className="group flex items-center gap-3 lg:gap-4 cursor-default">
                                    <FontAwesomeIcon icon={faTag} className={`text-lg lg:text-xl w-5 lg:w-6 transition-colors duration-300 ${activeTooltip === 'trade-pricing' ? 'text-green-600' : 'text-gray-30 group-hover:text-green-600'}`} />
                                    <span className={`text-sm lg:text-base transition-colors duration-300 ${activeTooltip === 'trade-pricing' ? 'text-primary' : 'group-hover:text-primary'}`}>Exclusive Trade Pricing</span>
                                </span>
                            </Tooltip>
                        </div>
                        <div className="py-3 lg:py-6 border-b border-gray-10">
                            <Tooltip
                                content="Shop our full collection online and place orders anytime, at your convenience."
                                side="bottom"
                                onOpenChange={createOpenChangeHandler('online-ordering')}
                            >
                                <span className="group flex items-center gap-3 lg:gap-4 cursor-default">
                                    <FontAwesomeIcon icon={faLaptop} className={`text-lg lg:text-xl w-5 lg:w-6 transition-colors duration-300 ${activeTooltip === 'online-ordering' ? 'text-green-600' : 'text-gray-30 group-hover:text-green-600'}`} />
                                    <span className={`text-sm lg:text-base transition-colors duration-300 ${activeTooltip === 'online-ordering' ? 'text-primary' : 'group-hover:text-primary'}`}>Online Ordering</span>
                                </span>
                            </Tooltip>
                        </div>
                        <div className="py-3 lg:py-6">
                            <Tooltip
                                content="Our team of design enthusiasts is here to support your projects every step of the way."
                                side="bottom"
                                onOpenChange={createOpenChangeHandler('supportive-community')}
                            >
                                <span className="group flex items-center gap-3 lg:gap-4 cursor-default">
                                    <FontAwesomeIcon icon={faPeopleLine} className={`text-lg lg:text-xl w-5 lg:w-6 transition-colors duration-300 ${activeTooltip === 'supportive-community' ? 'text-green-600' : 'text-gray-30 group-hover:text-green-600'}`} />
                                    <span className={`text-sm lg:text-base transition-colors duration-300 ${activeTooltip === 'supportive-community' ? 'text-primary' : 'group-hover:text-primary'}`}>Supportive Community</span>
                                </span>
                            </Tooltip>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default TradeDetailsSection
